// Entorno del frontend.
// - En desarrollo (npm start): NODE_ENV = 'development'  -> true
// - En producción (npm run build): NODE_ENV = 'production' -> false
// Esto evita tener que editar el repositorio en el servidor antes de compilar.
export const ENTORNO_ES_DESARROLLO = process.env.NODE_ENV !== 'production';

export const PRODUCCION = ENTORNO_ES_DESARROLLO ? 0 : 1; // compatibilidad: conserva semántica numérica
export const DESARROLLO = ENTORNO_ES_DESARROLLO ? 1 : 0; // compatibilidad: conserva semántica numérica

// Feature flags
// Si está en true, el módulo de Evaluación solo es visible/usable para usuarios con cargo que contenga 'TIC'.
// Poner en false cuando quieras habilitarlo a los demás roles permitidos.
export const EVALUACION_SOLO_TIC = false;
